function EbookProfileCardSkeleton() {
  return (
    <div className='flex space-x-5 w-full h-[150px] animate-pulse rounded-lg p-[10px] shadow border-[0.5px] border-gray-3'>
      <div className='w-[92px] bg-gray-3 rounded-lg' />
      <div className='flex flex-col justify-around space-y-2 mobile:hidden'>
        <div className='w-[100px] h-[14px] bg-gray-3 rounded-lg' />
        <div className='w-[300px] h-[14px] bg-gray-3 rounded-lg' />
        <div className='flex space-x-10'>
          <div className='flex space-x-2'>
            <div className='w-[18px] h-[18px] bg-gray-3 rounded-lg' />
            <div className='w-[80px] h-[18px] bg-gray-3 rounded-lg' />
          </div>
          <div className='flex space-x-2'>
            <div className='w-[18px] h-[18px] bg-gray-3 rounded-lg' />
            <div className='w-[80px] h-[18px] bg-gray-3 rounded-lg' />
          </div>
          <div className='flex space-x-2'>
            <div className='w-[18px] h-[18px] bg-gray-3 rounded-lg' />
            <div className='w-[80px] h-[18px] bg-gray-3 rounded-lg' />
          </div>
          <div className='flex space-x-2'>
            <div className='w-[18px] h-[18px] bg-gray-3 rounded-lg' />
            <div className='w-[80px] h-[18px] bg-gray-3 rounded-lg' />
          </div>
        </div>
      </div>
      <div className='flex flex-col justify-around desktop-tablet:hidden'>
        <div className='w-[80px] h-[14px] bg-gray-3 rounded-lg' />
        <div className='w-[140px] h-[14px] bg-gray-3 rounded-lg' />
        <div className='w-[180px] h-[14px] bg-gray-3 rounded-lg' />
      </div>
    </div>
  )
}

export { EbookProfileCardSkeleton }
